// utils/websiteOrdersApi.js
// Courses paid for on the institute's public website. A visitor pays there and
// is enrolled at once; staff see every order, finish the few that need a person,
// and switch the whole thing on in Settings → Payments.
// Backend: vc_be/routes/websiteOrderRoutes.js (services/websiteCheckout).
import apiClient from './apiClient';

const BASE = '/website-orders';

/** The Settings → Payments switch and what it is waiting on. */
export const getWebsiteCheckoutSettings = () => apiClient.get(`${BASE}/settings`);
export const updateWebsiteCheckoutSettings = (enabled) => apiClient.put(`${BASE}/settings`, { enabled: !!enabled });

/**
 * @param {object} params  { view: 'paid'|'attention'|'abandoned'|'refunded'|'all', search, courseId, page, pageSize }
 */
export const listWebsiteOrders = (params) => apiClient.get(BASE, { params });
export const getWebsiteOrder = (id) => apiClient.get(`${BASE}/${id}`);

/** Ask Razorpay again — "the buyer says they paid". */
export const checkWebsiteOrder = (id) => apiClient.post(`${BASE}/${id}/check`);

/**
 * Run the enrolment again.
 * @param {{ studentId?: string, acceptExisting?: boolean }} body
 *   studentId — credit this student (the buyer's email and mobile belong to two)
 *   acceptExisting — count the payment towards the enrolment they already hold
 */
export const retryWebsiteOrder = (id, body = {}) => apiClient.post(`${BASE}/${id}/retry`, body);

/** Refund a payment that was never placed, in full. A reason is required. */
export const refundWebsiteOrder = (id, reason) => apiClient.post(`${BASE}/${id}/refund`, { reason });

/** Send the buyer's receipt and login details again. */
export const resendWebsiteOrder = (id) => apiClient.post(`${BASE}/${id}/resend`);
